<template>
  <transition name="slide-up" mode="out-in">
    <div
      v-if="punishment && !loading"
      class="text-sm-left text-center punish-text"
    >
      <div v-if="!hasActiveBan && punishment.type === 'BAN'">
        <span class="green--text font-weight-medium">
          <v-icon color="green">mdi-check</v-icon>
          is not currently banned
        </span>
      </div>
      <div v-else>
        <span v-if="punishTypeTextCanExpire">is currently</span>
        <span v-else>was recently</span>
        <span
          :class="
            `${getSeverityColor}--text font-weight-black punish--type-text`
          "
        >
          {{ getPunishmentParticipleName }}
        </span>
        <span v-if="isPunishedForever && punishTypeTextCanExpire"
          >permanently</span
        >
        <span v-if="!isPunishedForever">
          for another
          <span class="font-weight-black">
            {{
              formatDistanceStrict(new Date(), new Date(punishment.expiration))
            }}
          </span>
        </span>
        <span v-if="punishment.reason">
          for
          <span class="font-weight-black">{{ punishment.reason }}</span>
        </span>
      </div>
    </div>
  </transition>
</template>
<script>
import { formatDistanceStrict } from "date-fns";
import {
  punishTypeTextCanExpireHelper,
  getSeverityColorHelper,
  getPunishmentParticipleNameHelper
} from "../helpers/punishments";

export default {
  props: {
    punishment: {
      type: Object,
      required: false
    },
    activeBans: Number
  },
  data: () => ({
    formatDistanceStrict,
    loading: false
  }),
  mounted() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 400);
  },
  computed: {
    isPunishedForever() {
      return this.punishment.expiration < 1;
    },

    hasActiveBan() {
      return this.activeBans > 0;
    },

    punishTypeTextCanExpire() {
      return punishTypeTextCanExpireHelper(this.punishment.type);
    },

    getSeverityColor() {
      return getSeverityColorHelper(this.punishment.type);
    },

    getPunishmentParticipleName() {
      return getPunishmentParticipleNameHelper(this.punishment.type);
    }
  }
};
</script>
<style lang="scss" scoped>
.punish-text {
  max-width: 695px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  padding-bottom: 8px;

  .punish--type-text {
    letter-spacing: 0.5px;
    font-size: 1em;
    line-height: 1em;
    white-space: nowrap;
  }
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}
.slide-up-enter, .slide-up-leave-to /* .slide-up-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(10px);
}
</style>
